import React, { useState, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

export const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
};

function Navbar() {
    const [click, setClick] = useState(false);
    const [scrolled, setScrolled] = useState(false);

    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    useEffect(() => {
        const handleScroll = () => setScrolled(window.scrollY > 10);
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Empêche le scroll du body quand le menu mobile est ouvert
    useEffect(() => {
        document.body.style.overflow = click ? 'hidden' : '';
        return () => { document.body.style.overflow = ''; };
    }, [click]);

    return (
        <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
            <div className='navbar-container'>

                {/* Logo */}
                <Link to="/" className='navbar-logo' onClick={() => { closeMobileMenu(); scrollToTop(); }}>
                    <img
                        src="/images/Trilogie_Restaurant-RS_logo.png"
                        alt="Trilogie Restaurant"
                        className='navbar-logo'
                    />
                </Link>

                {/* Hamburger */}
                <div className='menu-icon' onClick={handleClick} aria-label="Menu" role="button">
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>

                {/* Liens */}
                <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                    <li className='nav-item'>
                        <NavLink
                            to='/'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                            end
                        >
                            Accueil
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='/menu'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                        >
                            Menu
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='/equipe'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                        >
                            Équipe
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='/traiteur'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                        >
                            Traiteur
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='/vins'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                        >
                            Vins
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='/terrasse'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                        >
                            Terrasse
                        </NavLink>
                    </li>
                    <li className='nav-item nav-item--gift'>
                        <NavLink
                            to='/bon-cadeau'
                            className={({ isActive }) => isActive ? 'nav-links active' : 'nav-links'}
                            onClick={() => { closeMobileMenu(); scrollToTop(); }}
                            title="Bon cadeau"
                            aria-label="Bon cadeau"
                        >
                            <span className="nav-gift-text">Bon cadeau</span>
                            <i className="fa-solid fa-gift" />
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='https://loudstphotography.pixieset.com/trilogie-1/'
                            className='nav-links'
                            onClick={closeMobileMenu}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            Galerie <i className="fa-solid fa-arrow-up-right-from-square" />
                        </NavLink>
                    </li>
                    <li className='nav-item'>
                        <NavLink
                            to='https://bookings.zenchef.com/results?rid=379037&pid=1001'
                            className='nav-links'
                            onClick={closeMobileMenu}
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            Réserver <i className="fa-solid fa-arrow-up-right-from-square" />
                        </NavLink>
                    </li>
                </ul>

            </div>
        </nav>
    );
}

export default Navbar;
